import { required } from "vuelidate/lib/validators";
import moment from "moment";

export default class ContaReceberData {
  historico = "";
  documento = "";
  valor = 0;
  created_at = moment().format("YYYY-MM-DD");
  data_vencimento = moment().format("YYYY-MM-DD");
  tipo = "";
  recebido = false;
  repetir = false;
  banco = null;
  data_recebimento = null;
  vezes = null;
  parcelas = [];
  id_meio_pagamento = null;
  juros = 0;
  multa = 0;
  valor_total = 0;
  desconto = 0;
  obs = "";

  constructor({
    historico = "",
    valor = 0,
    created_at = moment().format("YYYY-MM-DD"),
    data_vencimento = moment().format("YYYY-MM-DD"),
    documento = "",
    recebido = false,
    repetir = false,
    banco = null,
    data_recebimento = null,
    vezes = null,
    parcelas = [],
    juros = 0,
    multa = 0,
    valor_total = 0,
    id_meio_pagamento = null,
    desconto = 0,
    obs = "",
  }) {
    this.historico = historico;
    this.valor = valor;
    this.created_at = created_at;
    this.data_vencimento = data_vencimento;
    this.documento = documento;
    this.recebido = recebido;
    this.banco = banco;
    this.data_recebimento = data_recebimento;
    this.repetir = repetir;
    this.vezes = vezes;
    this.parcelas = parcelas;
    this.juros = juros;
    this.multa = multa;
    this.valor_total = valor_total;
    this.id_meio_pagamento = id_meio_pagamento;
    this.desconto = desconto;
    this.obs = obs;
  }
}

export const ContaReceberDataRequired = {
  historico: {
    required,
  },
  valor: {
    required,
  },
  created_at: {
    required,
  },
  data_vencimento: {
    required,
  },
  documento: {
    required,
  },
};
